import React, {useState} from 'react';
import {Trans, useTranslation} from "react-i18next";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import {callAPI} from "../../../lib/common";
import LoadingButton from "../../Common/LoadingButton";


export default ({handleQuestionAsked}) => {
    const [saving, setSaving] = useState(false);
    const [t] = useTranslation();

    const handleYesNo = (e) => {
        const value = e.currentTarget.value;
        console.log('Value', value);
        setSaving(true);
        callAPI('/m/api/webshop/cart/auto-correction', 'PUT', {autoCorrection: value})
            .then(() => {
                handleQuestionAsked()
            })
            .finally(() => {
                setSaving(false);
            })
    }

    const open = true;
    return <Dialog aria-labelledby="simple-dialog-title" open={open}>
        <DialogTitle id="simple-dialog-title">
            <Trans>Auto correction</Trans>
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {t('Would you like us to perform colour correction of your photos free of charge before we produce them?')}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <LoadingButton isLoading={saving} color='primary' onClick={handleYesNo} value={0}>
                <Trans>No</Trans>
            </LoadingButton>
            <LoadingButton isLoading={saving} variant='contained' color='primary' onClick={handleYesNo} value={1}>
                <Trans>Yes</Trans>
            </LoadingButton>
        </DialogActions>
    </Dialog>
}